export default __webpack_public_path__ + "977840f.png";